import { hookObjectProperty } from '@slardar/sdk-template';
import { getDefaultBrowser, getDefaultHistory } from '../utils';
export var HISTORY_SUBJECT_NAME = 'history_0';
export var HASH_SUBJECT_NAME = 'hash_0';
export var observeHistory = function (next, tearDown) {
    var history = getDefaultHistory();
    if (!history)
        return;
    var restoreFns = [];
    var historyChangeListener = function () { return next(location.href); };
    var hookStateChange = function (origin) {
        return function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            try {
                origin.apply(history, params);
            }
            finally {
                historyChangeListener();
            }
        };
    };
    restoreFns.push(hookObjectProperty(history, 'pushState', hookStateChange)(), hookObjectProperty(history, 'replaceState', hookStateChange)());
    window.addEventListener('popstate', historyChangeListener, true);
    restoreFns.push(function () { return window.removeEventListener('popstate', historyChangeListener, true); });
    tearDown(function () {
        restoreFns.forEach(function (fn) { return fn(); });
    });
};
export var observeHash = function (next, tearDown) {
    var window = getDefaultBrowser();
    if (!window)
        return;
    var hashChangeListener = function () { return next(location.href); };
    window.addEventListener('hashchange', hashChangeListener, true);
    tearDown(function () { return window.removeEventListener('hashchange', hashChangeListener, true); });
};
export var hashSubject = [HASH_SUBJECT_NAME, observeHash];
export var historySubject = [HISTORY_SUBJECT_NAME, observeHistory];
//# sourceMappingURL=route.js.map